export default {
  apikey: "d9496365",
};
